import { palette, typography } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

export const link = css`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: ${palette.blueBase};
  text-decoration: none;
  font-weight: ${typography.body.fontWeight};
  font-family: ${typography.body.fontFamily};
  font-size: ${typography.body.sizes.lg.fontSize};
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;
